import addPassiveEventListener from '../principles/addPassiveEventListener';

// used in full-width Hagrid experiment MEX-4045
//
// Wires up the nav GET STARTED button to behave the same as the form's GET STARTED button
// i.e.:
// - progresses the user to question 1 when clicked

// Add class needed for Hagrid if form is available,
// otherwise just leave it as a link to the pricing page
if(document.querySelector('.lead-constructor__panel--welcome')) {
  $('.edge-button--info-prices').addClass('js-get-started');
}

// Fade in the button on the secondary nav when page is scrolled
addPassiveEventListener(window, 'scroll', () => {
  if(document.querySelector('.lead-constructor__panel--welcome')) {
    document.querySelector('.edge-button--info-prices')
      .classList.add('edge-button--info-prices--scrolled');
  }
});

$('.js-get-started').on('click', function(e) {
  e.preventDefault();
  if ($('.js-leadform--wizard').hasClass('interacted')){
    $('html, body').animate({ scrollTop: 0 }, 400);
  } else {
    $('.lead-constructor__panel--welcome .js-lead-constructor__next').click();
  }
});

// Scroll to top of page when user goes to next/previous panel
// or when they click get started button
$('.js-leadform--wizard').on(
  'click',
  ['.js-lead-constructor__next', '.js-lead-constructor__back'],
  function() {
    $('html, body').animate({ scrollTop: 0 }, 400);
  }
);



// WEBPACK FOOTER //
// ./client/app/scripts/components/full-width-get-started-button.js